import React from "react";
import { Link } from "react-router-dom"; // Import Link for routing
import "../Mask/Mask.css";

const Mask = () => {
  const leftCards = [
    {
      heading: "Green Savings Await!",
      text: "Get up to 50% off on our exclusive collection of indoor and outdoor plants. Limited time only!",
      img: "m1.webp",
    },
    {
      heading: "Grow Your Garden for Less!",
      text: "Buy 2 plants and get 1 free on all succulents and cacti. Start your indoor jungle today!",
      img: "m2.webp",
    },
  ];

  const rightCards = [
    {
      heading: "Fresh Plants, Fresher Deals!",
      text: "Enjoy flat 30% off on all flowering plants. Bring nature's beauty home now!",
      img: "m3.webp",
    },
    {
      heading: "Special Offers in Bloom!",
      text: "Up to 40% off on fruit and herb plants. Perfect for creating your edible garden.",
      img: "m4.webp",
    },
    {
      heading: "Nature’s Gifts, Now on Sale!",
      text: "Shop now and save big on air-purifying plants. Your healthier home starts here.",
      img: "m5.webp",
    },
  ];

  return (
    <div className="mask-container">
      <div className="left-grid">
        {leftCards.map((card, index) => (
          <div className="card-m" key={index}>
            <div className="card-content-m">
              <h3>{card.heading}</h3>
              <p>{card.text}</p>
              <Link to="/products/plants" className="shopn">
                Shop Now
              </Link>
            </div>
            <img src={card.img} alt={`Left Card ${index + 1}`} />
          </div>
        ))}
      </div>
      <div className="right-grid">
        {rightCards.map((card, index) => (
          <div className="card-m2" key={index}>
            <div className="card-content-m2">
              <h3>{card.heading}</h3>
              <p>{card.text}</p>
              <Link to="/products/plants" className="shopn">
                Shop Now
              </Link>
            </div>
            <img src={card.img} alt={`Right Card ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Mask;
